import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ThemeInputButtonBase from "../../../../components/ThemeInputButtonBase";
import {
  defaultCustomerOptions,
  defaultOptions,
} from "../../../../Helper/constant";
import APICall from "../../../../APICall";
import EndPoints from "../../../../APICall/EndPoints";
import { useSetUserDetails } from "../../../../components/SetUserDetails/SetUserDetails";
import modifyInitialValuesObject from "../modifyInitialValuesObject";
import { handleMarketValidation } from "../../../../Helper/functions";
import { setNewAccountInfo } from "../../../../store/slice/userAccountSlice";
import { notification } from "antd";
import { DefaultUserCol } from "../style";

const DefaultUserSetting = ({ validateFields, parentForm }) => {
  const dispatch = useDispatch();
  const setUserDetails = useSetUserDetails();

  //state
  const [loading, setloading] = useState(false);

  // redux
  const accountType = useSelector(
    (state) => state.userAccountSlice?.accountType
  );
  const basicInfo = useSelector((state) => state.userAccountSlice?.basicInfo);

  // life cycle
  useEffect(() => {
    dispatch(
      setNewAccountInfo({
        parent_key: "basicInfo",
        key: "defaultUser",
        value: "",
      })
    );
  }, [accountType]);

  // api call
  const getDefaultUser = async (type) => {
    setloading(true);
    try {
      let URL = `${EndPoints.getDefaultUser}${accountType}`;
      if (accountType === "customer") {
        URL = `${EndPoints.getDefaultUser}${accountType}&type=${type.value}`;
      }
      let response = await APICall("get", URL);

      if (response.status === 200 && response.data) {
        // console.log("defaultUser", response.data?.data);
        const userInfo = response?.data?.data?.[0];
        const m2m = accountType === "customer" ? true : false;
        const finalObj = setUserDetails(userInfo, m2m, true, parentForm);
        let modedVals = modifyInitialValuesObject(finalObj);
        parentForm.setFieldsValue({
          ...parentForm.getFieldsValue(),
          ...modedVals,
        });
        handleMarketValidation(parentForm, dispatch);
        setTimeout(() => {
          validateFields();
        }, 600);

        if (finalObj?.accountDetails?.newPositionSquareOffTime) {
          finalObj.accountDetails.newPositionSquareOffTime = null;
        }
        dispatch(setNewAccountInfo(finalObj));
        dispatch(
          setNewAccountInfo({
            parent_key: "basicInfo",
            key: "defaultUser",
            value: accountType !== "customer" ? "default" : type.value,
          })
        );
        dispatch(
          setNewAccountInfo({
            parent_key: "basicInfo",
            key: "importUserSettings",
            value: "",
          })
        );
      } else {
        notification.error({ message: response?.data?.message });
      }
    } catch (error) {
      notification.error({ message: error?.message });
    } finally {
      setloading(false);
    }
  };

  return (
    <DefaultUserCol
      xs={24}
      sm={16}
      md={10}
      lg={7}
      xl={accountType !== "customer" ? 2 : 5}
    >
      <ThemeInputButtonBase
        type="primary"
        onClick={getDefaultUser}
        active={basicInfo.defaultUser}
        options={
          accountType === "customer" ? defaultCustomerOptions : defaultOptions
        }
        loading={loading}
      />
    </DefaultUserCol>
  );
};

export default React.memo(DefaultUserSetting);
